import { OrderForm } from './order.form.model';
import { CurrentItem } from './current.item.model';
import { CurrentPlan } from './current.plan.model';
import { Service } from './service.model';
import { OfferType, ReplacementOffer } from './replacement.offer.model';
import { ItemOffer } from './item.offer.model';

export interface CreateOrderRequestArgs {
  offerReference: string;
  currentPlan: CurrentPlan;
  currentItem: CurrentItem;
  cost: number;
  selected: ReplacementOffer;
  protection: boolean;
  itemOffer: ItemOffer;
  extras: Service[];
  form: OrderForm;
  orderNumber: string;
  clientReferenceNumber: string;
}
export interface CreateOrderRequest {
  request_source: string;
  channel_code: string;
  channel_group_code: string;
  client_code: string;
  client_group_code: string;
  offer_reference: string;
  card_payment_details: {
    card_payment_flag: boolean;
    client_reference_number: string;
    order_number: string;
    amount: number;
    upgrade: number;
    currency: string;
    company_code: string;
    scheme_code: string;
    reference_number: string;
  };
  item_offer_details: {
    offer_upsell_flag: boolean;
    item_offer_hash: string;
    item_gid: string;
    offer_reference: string;
    item_code: string;
    manuf_code: string;
    warranty: number;
    purchase_price: number;
    model: string;
    period_Of_cover: number;
    fee: number;
    paymentType: string;
    number_of_payments: number;
    first_payment: number;
    subsequent_payment: number;
    item_urn?: string;
  };
  dd_details?: {
    account_number?: string;
    branch_code?: string;
    name: string;
    nom_pay_day: string;
    payment_token?: string;
  };
  pr_order_request: {
    offer_type: OfferType;
    supplier_id: number;
    cat_num: string;
    delivery_date: string;
    delivery_instructions: string;
    is_access_an_issue: boolean;
    is_not_ground_floor: boolean;
    email_address: string;
    mobile_phone: string;
    daytime_phone: string;
    services: Service[];
  };
}

export interface CreateOrderResponse {
  plan_number: string;
  error_status?: number;
}

export const CreateOrderResponse = undefined;
